// getPaymentChannelConditions.js

const zeroGuid = "00000000-0000-0000-0000-000000000000";

export function getPaymentChannelConditions(paymentChannelType) {
  const conditions = [];

  switch (paymentChannelType) {
    case 1: // PanelPayment
      conditions.push("PosCollectionCommissionDefinitionId ne null");
      conditions.push(`FirmUserId ne ${zeroGuid}`);
      conditions.push("isFromB2b eq false");
      break;

    case 2: // PanelLinkPayment
      conditions.push("PosCollectionCommissionDefinitionId ne null");
      conditions.push(`FirmUserId eq ${zeroGuid}`);
      conditions.push("PaymentRequestId ne null");
      conditions.push("isFromB2b eq false");
      break;

    case 3: // PanelStaticLinkPayment
      conditions.push("PosCollectionCommissionDefinitionId ne null");
      conditions.push(`FirmUserId eq null or FirmUserId eq ${zeroGuid}`);
      conditions.push("PaymentRequestId eq null");
      conditions.push("isFromB2b eq false");
      break;

    case 4: // B2BPanelPayment
      conditions.push("PosCollectionCommissionDefinitionId ne null");
      conditions.push(`FirmUserId ne ${zeroGuid}`);
      conditions.push("isFromB2b eq true");
      break;

    case 5: // B2BPanelLinkPayment
      conditions.push("PosCollectionCommissionDefinitionId ne null");
      conditions.push(`FirmUserId eq ${zeroGuid}`);
      conditions.push("PaymentRequestId ne null");
      conditions.push("isFromB2b eq true");
      break;

    case 6: // B2BGuestPayment
      conditions.push("PosCollectionCommissionDefinitionId ne null");
      conditions.push(`FirmUserId eq ${zeroGuid}`);
      conditions.push("PaymentRequestId eq null");
      conditions.push("isFromB2b eq true");
      break;

    case 7: // ApiPayment
      conditions.push("PosCollectionCommissionDefinitionId eq null");
      break;

    default:
      // no conditions
      break;
  }

  return conditions;
}
